// React-Redux
import { useSelector } from "react-redux";

// React Query
import { useQuery } from "@tanstack/react-query";

// MUI
import { Box, Stack } from "@mui/material";

// API
import { getProviderList } from "@Settings/api/AdministrationTools/queries";

// Components
import SmartSelector from "@/Layouts/components/InputComponents/SmartSelector";
import LogInButton from "@Settings/Layouts/LogInButton";

// Types
import { RootState } from "@/redux/store";
import { IAdministrationTools } from "@Settings/types/administrationTools/model";

type AssetManagementSystemProps = {
	isExpanded: boolean;
	administrationTools: IAdministrationTools;
};
export default function PhoneServiceProvider(props: Readonly<AssetManagementSystemProps>) {
	const location = useSelector((state: RootState) => state.location.location);
	const locationId = location?.locationId;

	/***************************************** QUERIES *****************************************/
	const { data, isLoading } = useQuery({
		queryKey: ["phoneServiceProvider", locationId],
		queryFn: async () => getProviderList(locationId as string, "PSP"),
		enabled: Boolean(locationId) && props.isExpanded,
		staleTime: Infinity,
	});

	/***************************************** HANDLERS *****************************************/
	const handleClickPhoneServiceProviderLogin = () => {
		// Intentionally left blank, required for future implementation PhoneServiceProvider
	};

	return (
		<Stack direction={"row"} spacing={3} marginTop={"5px"}>
			<Box width={200}>
				<SmartSelector
					showBy={"providerName"}
					selectBy={"providerName"}
					options={(data ?? []) as unknown as object[]}
					selected={props.administrationTools?.integrations?.phoneServiceProvider}
					inputProps={{
						placeholder: "Select a phone provider",
					}}
					listBoxProps={{
						sx: { maxHeight: "220px" },
					}}
					loading={isLoading}
					onChangeAction={() => {}}
				/>
			</Box>
			<LogInButton onClick={handleClickPhoneServiceProviderLogin} />
		</Stack>
	);
}
